import * as yup from "yup";

const schema = yup.object().shape({
  detailedInstructions: yup
    .string()
    .required()
    .matches(
      /^(?!\s+$).+/,
      "Please provide valid values for detailed instructions"
    )
    .label("Detailed Correction"),
});

export default schema;
